module.exports = __webpack_public_path__ + "img/ua_get.fd7db85.png";